import { useGetTenantQuery } from './useGetTenantQuery';

export const useGetSubdomainQuery = () => {
  const { tenant, isFetching } = useGetTenantQuery();

  const { subdomain } = tenant;

  return { isLoading: isFetching, subdomain, tenant };
};
